import { render, staticRenderFns } from "./VoiceAgentChannelStatusWidget.vue?vue&type=template&id=560e212a&scoped=true"
import script from "./VoiceAgentChannelStatusWidget.vue?vue&type=script&lang=js"
export * from "./VoiceAgentChannelStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./VoiceAgentChannelStatusWidget.vue?vue&type=style&index=0&id=560e212a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e212a",
  null
  
)

export default component.exports